import { NAME } from './constants';
import { router } from './router';

export const WmsSecurityguard = {
	name: NAME,
	router,
};
